import { IconButton, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import type { ReactNode } from "react";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  action?: ReactNode;
}

const ModalHeader = ({ title, onClose, action }: ModalHeaderProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      alignSelf="stretch"
      width="100%"
      height="52px"
      padding={`${nawyTheme.nawy.spacing.xs} ${nawyTheme.nawy.spacing.md}`}
      gap={nawyTheme.nawy.spacing.md}
      borderBottom={`1px solid ${nawyTheme.nawy.colors.semantic.border.secondary}`}
      bgcolor={nawyTheme.nawy.colors.semantic.layer.primary}
    >
      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.lg.semibold,
        }}
        flex="1 1 0"
        color={nawyTheme.nawy.colors.semantic.text.primary}
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        maxWidth="100%"
      >
        {title}
      </Typography>

      {action}

      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Stack>
  );
};

export default ModalHeader;
